import React, { useState, useEffect } from 'react';
import Modal from '../../components/Modals/Modal';
import ReactSelect from '../../components/Inputs/ReactSelect';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import useUsers from '../../store/users/usersContext';


function AddClinicPartnerModal({
  showAddClinicPartner,
  setShowAddClinicPartner,
  clinicId,
  onAdd,
  clinicPartners
}) {

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });

  const [allPartners, setAllPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);

  const { getAllPartners } = useUsers();

  useEffect(() => {
    getAllPartners().then(res => setAllPartners(res.data))
  
  }, [clinicId]);
  
  const selectPartnerOptions = [];

  if (allPartners && clinicPartners) allPartners.forEach((partner) => {
  if (clinicPartners.some(clinicPartner => clinicPartner._id === partner._id)) {
      return;
    } else if (partner && partner.user_id){
      selectPartnerOptions.push({
        label: partner.user_id.first_name + ' ' + partner.user_id.last_name, 
        value: partner.user_id._id
      });
    }
  })
  
  const handleCancelAddCollaborator = () => {
    setShowAddClinicPartner(false);
  }

  const handleAddCollaborator = () => {
    if (!selectedPartner) {
      return setFormError({
        field: 'partner',
        msg: "Please select a partner."
      });
    }  
    onAdd(selectedPartner.value)
    setSelectedPartner(null);
  }

  return (
    <Modal title={'Add Collaborator'} show={showAddClinicPartner} hide={() => setShowAddClinicPartner(false)}>
      <div className='flex flex-col'>
        <div className='grid grid-cols-1 gap-y-1 my-8'>
          <span className='mb-2'>Please select a partner to add:</span>
          <ReactSelect 
            options={selectPartnerOptions} 
            value={selectedPartner?.label}
            onChange={(e) => setSelectedPartner({label: e.label, value: e.value })}
          />
          {formError.field === 'partner' && 
          <span className="text-red-400 text-sm">{formError.msg}</span>
          }
        </div>
        <div className='grid grid-cols-2 gap-x-2'>
          <SecondaryButton onClick={handleCancelAddCollaborator} text='Cancel'/>
          <PrimaryButton text={'Add partner'} onClick={handleAddCollaborator} />
        </div>
      </div>
    </Modal>
  )
}

export default AddClinicPartnerModal
